import { entryPointId } from 'settings/app/constants'
import _ from 'lodash'

/**
 * check if new bookmark has different search context
 * @param newBookmark
 * @param bookmarkState
 * @returns {{searchContextDiff: *[], isNewSearchBookmark: boolean}}
 */
export const bookmarksSearchContextHasChanged = ({
  newBookmark,
  bookmarkState,
}) => {
  const { type } = newBookmark
  let isNewSearchBookmark = false
  const searchContextDiff = []

  switch (type) {
    case entryPointId.HOSPITALS:
      isNewSearchBookmark = !_.isEqual(
        // filter falsy values with pickBy
        _.pickBy(bookmarkState.searchParams, _.identity),
        _.pickBy(newBookmark.searchParams, _.identity)
      )
      break

    case entryPointId.CAREHOMES:
      if (
        bookmarkState.searchParams.carehomes_care_typ !==
        newBookmark.searchParams.carehomes_care_typ
      ) {
        isNewSearchBookmark = true
        searchContextDiff.push('carehomes_care_typ')
      }

      if (
        bookmarkState.searchParams.carehomes_focus !==
        newBookmark.searchParams.carehomes_focus
      ) {
        isNewSearchBookmark = true
        searchContextDiff.push('carehomes_focus')
      }
      break

    case entryPointId.DAYANDNIGHTCARE:
      if (
        bookmarkState.searchParams.PR_TYP !== newBookmark.searchParams.PR_TYP
      ) {
        isNewSearchBookmark = true
        searchContextDiff.push('PR_TYP')
      }
      break

    case entryPointId.CARESERVICES:
      if (
        bookmarkState.searchParams.PE_ANG_KRANKENPFLEGE !==
        newBookmark.searchParams.PE_ANG_KRANKENPFLEGE
      ) {
        isNewSearchBookmark = true
        searchContextDiff.push('PE_ANG_KRANKENPFLEGE')
      }
      break

    default:
      isNewSearchBookmark = false
  }

  return { isNewSearchBookmark, searchContextDiff }
}

/**
 * results which can not added to bookmarks when they have different search context
 * @type {(string)[]}
 */
export const CHECK_BOOKMARK_CONTEXT = [
  entryPointId.HOSPITALS,
  entryPointId.CAREHOMES,
  entryPointId.DAYANDNIGHTCARE,
  entryPointId.CARESERVICES,
]
